/**
 * True only for single-slash app-relative paths. Rejects protocol-relative
 * URLs ('//evil.example.com') and the backslash variant ('/\evil.example.com'),
 * both of which browsers resolve off-site when used as a redirect target or
 * href, so a returnTo can never send the user to another origin.
 */
export const isAppRelativeReturnTo = (
  value: string | undefined
): value is string =>
  typeof value === 'string' &&
  value.startsWith('/') &&
  !value.startsWith('//') &&
  !value.startsWith('/\\');
